module.exports = __webpack_public_path__ + "static/control-image-fc111b7702c0316b1cfa88c974afc697.png";